import { useCallback, useMemo } from 'react';
import type { Bedrooms } from 'app/shared/types/Bedrooms';
import type { PropertyTypes } from 'app/shared/types/PropertyTypes';
import { handleMarketTrendsFilterChange } from 'app/shared/flux/actions/FilterActions';
import filterUtils from 'app/shared/utils/filterUtils';

import type { bedroomsType, FilterType, propertyTypesType } from 'app/shared/types/Filters';
import type { Dispatch } from '@reduxjs/toolkit';

export function useMarketTrendsFilters(filter: FilterType, dispatch: Dispatch<any>) {
  const bedrooms = useMemo(() => filterUtils.filterToBedroomsEnum(filter.bedrooms as bedroomsType), [filter]);
  const setBedrooms = useCallback(
    (newBedrooms: Bedrooms) => {
      return dispatch(
        handleMarketTrendsFilterChange({
          bedrooms: filterUtils.bedroomsEnumToFilter(newBedrooms),
          propertyTypes: filter.propertyTypes,
        }),
      );
    },
    [dispatch, filter],
  );
  const propertyTypes = useMemo(
    () => filterUtils.filterToPropertyTypesEnum(filter.propertyTypes as propertyTypesType),
    [filter],
  );
  const setPropertyTypes = useCallback(
    (newPropertyTypes: PropertyTypes) => {
      return dispatch(
        handleMarketTrendsFilterChange({
          bedrooms: filter.bedrooms,
          propertyTypes: filterUtils.propertyTypesEnumToFilter(newPropertyTypes),
        }),
      );
    },
    [dispatch, filter],
  );
  return { bedrooms, setBedrooms, propertyTypes, setPropertyTypes };
}
